import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Formik } from "formik";
import { useState } from "react";

import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import TextInput from "../../../components/misc/TextInput";
import { useAppDispatch } from "../../../redux/hooks";

import { postUserDetails } from "../../../redux/api/admin.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../helpers/apiHelper";

interface initialValuesInterface {
  userName: string;
  firstName: string;
  lastName: string;
  password: string;
  verifyPassword: string;
}

const initialValues: initialValuesInterface = {
  userName: "",
  firstName: "",
  lastName: "",
  password: "",
  verifyPassword: "",
};

const productSchema = Yup.object({
  userName: Yup.string().required("Campul este obligatoriu"),
  firstName: Yup.string().required("Campul este obligatoriu"),
  lastName: Yup.string().required("Campul este obligatoriu"),
  password: Yup.string().required("Campul este obligatoriu"),
  verifyPassword: Yup.string()
    .required("Campul este obligatoriu")
    .oneOf([Yup.ref("password"), null], "Parolele nu se potrivesc"),
});

function CreateUser() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSaveProductDetails = async (value: initialValuesInterface) => {
    setIsLoading(true);

    const resultAction = await dispatch(
      postUserDetails({
        userId: null,
        userDetails: value,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postUserDetails) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postUserDetails) ===
      endpointStatus.fulfilled
    ) {
      navigate(-1);
    }
  };

  return (
    <ContentCard cardTitle="Creeaza utilizator">
      <Formik
        initialValues={initialValues}
        validationSchema={productSchema}
        onSubmit={handleSaveProductDetails}>
        {({
          isValid,
          errors,
          touched,
          getFieldProps,
          handleSubmit,
          isSubmitting,
        }) => (
          <form
            className="w-full"
            onSubmit={handleSubmit}
            noValidate
            id="kt_login_signin_form">
            <TextInput
              label="Username"
              name="userName"
              error={errors["userName"]}
              touched={touched["userName"]}
              inputProps={getFieldProps("userName")}
            />
            <TextInput
              label="Nume"
              name="lastName"
              error={errors["lastName"]}
              touched={touched["lastName"]}
              inputProps={getFieldProps("lastName")}
            />
            <TextInput
              label="Prenume"
              name="firstName"
              error={errors["firstName"]}
              touched={touched["firstName"]}
              inputProps={getFieldProps("firstName")}
            />
            <TextInput
              label="Parola"
              name="password"
              type="password"
              error={errors["password"]}
              touched={touched["password"]}
              inputProps={getFieldProps("password")}
            />
            <TextInput
              label="Verifica Parola"
              name="verifyPassword"
              type="password"
              error={errors["verifyPassword"]}
              touched={touched["verifyPassword"]}
              inputProps={getFieldProps("verifyPassword")}
            />

            <div className="flex justify-between">
              <CustomButton
                type="submit"
                variant="outlined"
                onClick={handleGoBack}>
                Anuleaza
              </CustomButton>
              <CustomButton
                type="submit"
                variant="contained"
                loading={isSubmitting || isLoading}
                disabled={!isValid || isSubmitting}>
                Salveaza
              </CustomButton>
            </div>
          </form>
        )}
      </Formik>
    </ContentCard>
  );
}

export default CreateUser;
